import { reactive, ref, watch } from 'vue'
import { getUnitList as getUnitListApi, saveUnitInfo, deleteUnit as deleteUnitApi } from '@/api/project/integralSeckill/manageGoods'
import { message } from 'ant-design-vue'

export default function useUnit(getContainer) {
  message.config({
    getContainer: getContainer.value,
  })
  watch(getContainer, (val) => {
    message.config({
      getContainer: val,
    })
  })
  // 单位相关
  const unitList = ref([])
  const unitModal = reactive({
    show: false,
    name: '',
  })
  //新增单位
  const addUnit = () => {
    unitModal.name = ''
    unitModal.show = true
  }
  const confirmAddUnit = async () => {
    if (unitModal.name === '') {
      return message.error('请填写单位名称')
    }
    const body = {
      unit: unitModal.name,
    }
    unitModal.loading = true
    const res = await saveUnitInfo(body)
    unitModal.loading = false
    if (res.code === 0) {
      unitModal.show = false
      message.success('保存成功')
      getUnitList()
    } else {
      message.error(res.msg)
    }
  }
  //删除单位
  const deleteUnit = (e, id) => {
    e.stopPropagation()
    const body = {
      id: id,
    }
    deleteUnitApi(body).then((res) => {
      if (res.code == 0) {
        message.success('删除成功')
        getUnitList()
      } else {
        message.error(res.msg)
      }
    })
  }
  const getUnitList = () => {
    getUnitListApi().then((res) => {
      if (res.code === 0) {
        unitList.value = res.data.list.map((v) => {
          return {
            value: v.id,
            label: v.unit,
          }
        })
      }
    })
  }
  return {
    unitList,
    unitModal,
    addUnit,
    confirmAddUnit,
    deleteUnit,
    getUnitList,
  }
}
